import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { Box, Button } from '@mui/material'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { H3 } from '../../../layouts/TextStyles'
import CustomInput from '../../../components/muiComponents/customInput'
import DatePicker from '../../../components/muiComponents/datePicker/DatePicker'
import { salesApi } from '../../../features/sales/sales'
import { formatDateToCalendarDate } from '../../../utils/functions'
import SalesReportTable from './components/SalesReportTable'
import Sentinel from '../../../components/infiniteScroll/Sentinel'
import { usePaginatedList } from '../../../app/hooks/usePaginatedList'
import {
    Content,
    Header,
    TotalInfoText,
    Title,
    TotalInfoBox,
    TotalSum,
    Wrapper,
    DateWrapper,
    ComponentsWrapper,
    SearchStyles,
    FilterBox
} from './style'

const SalesReportListPage = () => {
    const { formatMessage } = useIntl()
    const [startDate, setStartDate] = React.useState<Date>()
    const [endDate, setEndDate] = React.useState<Date>()
    const [filter, setFilter] = useState('')
    const [type, setType] = useState('PAID')
    // Поиск и даты применяются кнопкой, а не на каждое нажатие клавиши
    const [applied, setApplied] = useState(0)

    const [
        fetchSalesProfit,
        { data: volume = 0, isFetching: isFetchingSalesProfit },
    ] = salesApi.useLazyFetchSalesProfitQuery()

    const [fetchSalesAnalyzes] = salesApi.useLazyFetchSalesAnalyzesQuery()

    const dateRange = () => ({
        startDate: startDate
            ? formatDateToCalendarDate(startDate, '-', ['yyyy', 'mm', 'd'])
            : undefined,
        endDate: endDate
            ? formatDateToCalendarDate(endDate, '-', ['yyyy', 'mm', 'd'])
            : undefined,
    })

    const { rows, isLoading, loadedPages, sentinelRef } = usePaginatedList(
        (page, size) =>
            fetchSalesAnalyzes({ ...dateRange(), filter, page, size, type }).unwrap(),
        [type, applied],
    )

    const isFetching = isFetchingSalesProfit || isLoading

    const handleChangeType = (e, newType) => {
        setType(newType)
    }

    useEffect(() => {
        fetchSalesProfit({ ...dateRange(), filter })
    }, [type, applied])

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3> {formatMessage({ id: 'salesReport' })} </H3>
                    </Title>
                    
                    <FilterBox>
                         <Tabs value={type} onChange={handleChangeType} aria-label="lab API tabs example">
                            <Tab label="Төленгендер" value="PAID" />
                            <Tab label="Барлығы" value="ALL" />
                        </Tabs>

                        <TotalSum>
                            <TotalInfoText>
                                {formatMessage({ id: 'totalCash' })}
                            </TotalInfoText>
                            <TotalInfoBox>{volume?.toLocaleString()} т</TotalInfoBox>
                        </TotalSum>
                    </FilterBox>
                     
                </Header>

                <ComponentsWrapper>
                    <Box sx={SearchStyles.filterBox}>
                        <Box sx={SearchStyles.searchBox}>
                            <CustomInput
                                sx={SearchStyles.search}
                                margin="none"
                                type="text"
                                placeholder={formatMessage({ id: 'search' })}
                                size="small"
                                onChange={(e) => setFilter(e.target.value)}
                            />

                            <Button
                                variant="contained"
                                onClick={() => setApplied((value) => value + 1)}
                            >
                                {formatMessage({ id: 'search' })}
                            </Button>
                        </Box>
                    </Box>

                    <DateWrapper>
                        <DatePicker
                            label={formatMessage({ id: 'startDateTime' })}
                            value={startDate}
                            small={true}
                            handleChange={(event) => setStartDate(event)}
                        />

                        <DatePicker
                            label={formatMessage({ id: 'endDateTime' })}
                            value={endDate}
                            small={true}
                            handleChange={(event) => setEndDate(event)}
                        />

                        <Button
                            variant="contained"
                            onClick={() => setApplied((value) => value + 1)}
                        >
                            {formatMessage({ id: 'withdraw' })}
                        </Button>
                    </DateWrapper>
                </ComponentsWrapper>

                {isFetching && loadedPages === 0 ? (
                    <LinearProgress />
                ) : (
                    <>
                        <SalesReportTable
                            isFetching={isLoading}
                            analyzes={rows}
                        />

                        <Sentinel ref={sentinelRef} isLoading={isLoading} />
                    </>
                )}
            </Content>
        </Wrapper>
    )
}
export default SalesReportListPage

